module.exports = __webpack_public_path__ + "static/media/hongdanshan_plant.03856091.webp";